import React, { useState } from "react";
import {
    ComposableMap,
    Geographies,
    Geography,
    Marker,
} from "react-simple-maps";
import { AppConstant } from "../AppConstant";

const geoUrl = "https://cdn.jsdelivr.net/npm/us-atlas@3/states-10m.json";

// const statesWithCoordinates = [
//     { name: "Ohio", coordinates: [-82.9071, 40.4173], operated: true },
//     { name: "Kentucky", coordinates: [-84.2700, 37.8393], operated: true },
//     { name: "Indiana", coordinates: [-86.1349, 40.2672], operated: true },
//     { name: "Michigan", coordinates: [-85.6024, 44.3148], operated: true },
//     { name: "Nebraska", coordinates: [-99.9018, 41.4925], operated: true },
//     { name: "Pennsylvania", coordinates: [-77.1945, 41.2033], operated: true },
//     { name: "South Carolina", coordinates: [-80.9450, 33.8361], operated: true },
//     { name: "Tennessee", coordinates: [-86.5804, 35.5175], operated: true },
//     { name: "Oklahoma", coordinates: [-97.0929, 35.0078], operated: true },
//     { name: "Washington", coordinates: [-120.7401, 47.7511], operated: true },
//     { name: "Virginia", coordinates: [-78.6569, 37.4316], operated: true },
//     { name: "Florida", coordinates: [-81.5158, 27.6648], operated: true },
//     { name: "Texas", coordinates: [-99.9018, 31.9686], operated: true },
//     { name: "West Virginia", coordinates: [-80.4549, 38.5976], operated: true },
//     { name: "Missouri", coordinates: [-91.8318, 37.9643], operated: true },
//     { name: "Arizona", coordinates: [-111.0937, 34.0489], operated: true },
//     { name: "Louisiana", coordinates: [-92.3291, 30.9843], operated: true },
//     { name: "Illinois", coordinates: [-89.3985, 40.6331], operated: true },
//     { name: "Maryland", coordinates: [-76.6413, 39.0458], operated: true },
//     { name: "Arkansas", coordinates: [-92.2896, 35.2010], operated: true },
//     { name: "New York", coordinates: [-75.4999, 43.0000], operated: true },
//     { name: "New Mexico", coordinates: [-105.8701, 34.5199], operated: true },
//     { name: "Kansas", coordinates: [-98.4842, 39.0119], operated: true },
//     { name: "Oregon", coordinates: [-120.5542, 43.8041], operated: true },
//     { name: "Georgia", coordinates: [-82.9001, 32.1656], operated: true },
//     { name: "Minnesota", coordinates: [-94.6859, 46.7296], operated: true },
//     { name: "North Carolina", coordinates: [-79.0193, 35.7596], operated: true },
//     { name: "Iowa", coordinates: [-93.0977, 42.0329], operated: true },
//     { name: "Connecticut", coordinates: [-72.7554, 41.6032], operated: true },
//     { name: "Colorado", coordinates: [-105.7821, 39.5501], operated: true },
//     { name: "Wisconsin", coordinates: [-88.7879, 43.7844], operated: true },
//     { name: "New Hampshire", coordinates: [-71.5724, 43.1939], operated: true },
//     { name: "Nevada", coordinates: [-116.4194, 38.8026], operated: true },
//     { name: "Mississippi", coordinates: [-89.6787, 32.3547], operated: true },
//     { name: "North Dakota", coordinates: [-100.4659, 47.5515], operated: true },
//     { name: "Montana", coordinates: [-110.3626, 46.8797], operated: true },

//     // Non-operating states
//     { name: "Alaska", coordinates: [-149.4937, 64.2008], operated: false },
//     { name: "Hawaii", coordinates: [-155.5828, 20.7967], operated: false },
//     { name: "Idaho", coordinates: [-114.7420, 44.0682], operated: false },
//     { name: "Maine", coordinates: [-69.4455, 45.2538], operated: false },
//     { name: "Rhode Island", coordinates: [-71.4774, 41.5801], operated: false },
//     { name: "Delaware", coordinates: [-75.5277, 38.9108], operated: false },
//     { name: "Vermont", coordinates: [-72.5778, 44.5588], operated: false },
//     { name: "Wyoming", coordinates: [-107.2903, 43.0759], operated: false },

//     // Adding missing states
//     { name: "South Dakota", coordinates: [-99.9018, 43.9695], operated: false },
//     { name: "Utah", coordinates: [-111.0937, 39.3210], operated: false },
//     { name: "California", coordinates: [-119.4179, 36.7783], operated: false },
//     { name: "Alabama", coordinates: [-86.9023, 32.3182], operated: false },

// ];

const statesWithCoordinates = [
    { name: "Ohio", code: "OH", coordinates: [-82.9071, 40.4173], operated: true },
    { name: "Kentucky", code: "KY", coordinates: [-84.2700, 37.8393], operated: true },
    { name: "Indiana", code: "IN", coordinates: [-86.1349, 40.2672], operated: true },
    { name: "Michigan", code: "MI", coordinates: [-85.6024, 44.3148], operated: true },
    { name: "Nebraska", code: "NE", coordinates: [-99.9018, 41.4925], operated: true },
    { name: "Pennsylvania", code: "PA", coordinates: [-77.1945, 41.2033], operated: true },
    { name: "South Carolina", code: "SC", coordinates: [-80.9450, 33.8361], operated: true },
    { name: "Tennessee", code: "TN", coordinates: [-86.5804, 35.5175], operated: true },
    { name: "Oklahoma", code: "OK", coordinates: [-97.0929, 35.0078], operated: true },
    { name: "Washington", code: "WA", coordinates: [-120.7401, 47.7511], operated: true },
    { name: "Virginia", code: "VA", coordinates: [-78.6569, 37.4316], operated: true },
    { name: "Florida", code: "FL", coordinates: [-81.5158, 27.6648], operated: true },
    { name: "Texas", code: "TX", coordinates: [-99.9018, 31.9686], operated: true },
    { name: "West Virginia", code: "WV", coordinates: [-80.4549, 38.5976], operated: true },
    { name: "Missouri", code: "MO", coordinates: [-91.8318, 37.9643], operated: true },
    { name: "Arizona", code: "AZ", coordinates: [-111.0937, 34.0489], operated: true },
    { name: "Louisiana", code: "LA", coordinates: [-92.3291, 30.9843], operated: true },
    { name: "Illinois", code: "IL", coordinates: [-89.3985, 40.6331], operated: true },
    { name: "Maryland", code: "MD", coordinates: [-76.6413, 39.0458], operated: true },
    { name: "Arkansas", code: "AR", coordinates: [-92.2896, 35.2010], operated: true },
    { name: "New York", code: "NY", coordinates: [-75.4999, 43.0000], operated: true },
    { name: "New Mexico", code: "NM", coordinates: [-105.8701, 34.5199], operated: true },
    { name: "Kansas", code: "KS", coordinates: [-98.4842, 39.0119], operated: true },
    { name: "Oregon", code: "OR", coordinates: [-120.5542, 43.8041], operated: true },
    { name: "Georgia", code: "GA", coordinates: [-82.9001, 32.1656], operated: true },
    { name: "Minnesota", code: "MN", coordinates: [-94.6859, 46.7296], operated: true },
    { name: "North Carolina", code: "NC", coordinates: [-79.0193, 35.7596], operated: true },
    { name: "Iowa", code: "IA", coordinates: [-93.0977, 42.0329], operated: true },
    { name: "Connecticut", code: "CT", coordinates: [-72.7554, 41.6032], operated: true },
    { name: "Colorado", code: "CO", coordinates: [-105.7821, 39.5501], operated: true },
    { name: "Wisconsin", code: "WI", coordinates: [-88.7879, 43.7844], operated: true },
    { name: "New Hampshire", code: "NH", coordinates: [-71.5724, 43.1939], operated: true },
    { name: "Nevada", code: "NV", coordinates: [-116.4194, 38.8026], operated: true },
    { name: "Mississippi", code: "MS", coordinates: [-89.6787, 32.3547], operated: true },
    { name: "North Dakota", code: "ND", coordinates: [-100.4659, 47.5515], operated: true },
    { name: "Montana", code: "MT", coordinates: [-110.3626, 46.8797], operated: true },

    // Non-operating states
    { name: "Alaska", code: "AK", coordinates: [-149.4937, 64.2008], operated: false },
    { name: "Hawaii", code: "HI", coordinates: [-155.5828, 20.7967], operated: false },
    { name: "Idaho", code: "ID", coordinates: [-114.7420, 44.0682], operated: false },
    { name: "Maine", code: "ME", coordinates: [-69.4455, 45.2538], operated: false },
    { name: "Rhode Island", code: "RI", coordinates: [-71.4774, 41.5801], operated: false },
    { name: "Delaware", code: "DE", coordinates: [-75.5277, 38.9108], operated: false },
    { name: "Vermont", code: "VT", coordinates: [-72.5778, 44.5588], operated: false },
    { name: "Wyoming", code: "WY", coordinates: [-107.2903, 43.0759], operated: false },

    // Adding missing states
    { name: "South Dakota", code: "SD", coordinates: [-99.9018, 43.9695], operated: false },
    { name: "Utah", code: "UT", coordinates: [-111.0937, 39.3210], operated: false },
    { name: "California", code: "CA", coordinates: [-119.4179, 36.7783], operated: false },
    { name: "Alabama", code: "AL", coordinates: [-86.9023, 32.3182], operated: false },
];


export default function USAMap() {

    const [hoveredState, setHoveredState] = useState(null);

    return (
        <div
            style={{
                width: "100%",
                minHeight: "100%",
                 backgroundColor: "white",
                // backgroundImage: AppConstant.backgroundtextilerdesign,
                // backgroundAttachment: AppConstant.backgroundAttachmentscroller,

                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                paddingTop: "20px",
            }}
        >
            {/* Heading */}
            <div style={{ textAlign: "center", }}>
                {/* <h1 style={{ margin: 0, fontSize: "2rem", color: "#333" }}>
                    States We Operate In / Our Footprint Across the USA
                </h1> */}
                <h2 style={{ color: "#0A1733", fontSize: '60px', textAlign: 'center' }}>
                    Our Footprint<span style={{ color: '#f37021' }}> Across the USA</span>
                </h2>
                <p style={{

                    maxWidth: 940,
                    margin: "12px auto 32px",
                    fontSize: '1rem',
                    textAlign: 'center',
                    marginBottom: '40px',
                    fontWeight: "bold",
                    fontStyle: 'italic',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    // color: 'lightgrey',
                    color: '#0A1733',
                    // textTransform: "capitalize",

                    // textDecoration: "underline 2px rgb(255, 101, 0)",

                    textUnderlineOffset: "10px",
                    letterSpacing: "2px",
                }}>
                    We Take Pride in Delivering High-Quality Projects Across Multiple States. The Map Below Highlights All the States Where Our Company Has Successfully Completed Projects, as Well as the Regions Where We Are Planning Future Operations.
                </p>
            </div>

            {/* Map */}
            <div style={{ width: "90%", maxWidth: "900px", maxHeight: "600px" }}>
                <ComposableMap
                    projection="geoAlbersUsa"
                    projectionConfig={{ scale: 800 }}
                    style={{ width: "100%", height: "100%" }}
                >
                    <Geographies geography={geoUrl}>
                        {({ geographies }) =>
                            geographies.map((geo) => {
                                const state = statesWithCoordinates.find(
                                    (s) => s.name === geo.properties.name
                                );
                                const isOperated = state ? state.operated : false;
                                return (
                                    <Geography
                                        key={geo.rsmKey}
                                        geography={geo}
                                        style={{
                                            default: {
                                                fill: isOperated ? "#FFA500" : "rgb(249, 179, 104)",
                                                stroke: "white",
                                                strokeWidth: 0.5,
                                            },
                                            hover: {
                                                fill: isOperated ? "#0A1733" : "#4D5A80",
                                                stroke: "white",

                                                strokeWidth: 0.7,
                                            },
                                            pressed: {
                                                fill: "#ff6600",
                                                stroke: "#0033cc",
                                            },
                                        }}
                                        onMouseEnter={() => setHoveredState(geo.properties.name)}
                                        onMouseLeave={() => setHoveredState(null)}
                                    />
                                );
                            })
                        }
                    </Geographies>

                    {/* State markers with names */}
                    {statesWithCoordinates.map(({ name, code, coordinates, operated }) => (
                        <Marker key={name} coordinates={coordinates}>
                            {/* <circle r={operated ? 6 : 4} fill={operated ? "blue" : "gray"} /> */}
                            <text
                                textAnchor="middle"
                                y={-10}
                                style={{
                                    fontFamily: "system-ui",
                                    fill:
                                        hoveredState === name
                                            ? "white"
                                            : operated
                                                ? "black"
                                                : "black",
                                    fontSize: 10,
                                    // fontWeight:'bold',
                                }}
                            >
                                {code}
                            </text>


                        </Marker>
                    ))}
                </ComposableMap>
            </div>

            {/* Legend Section */}
            {/* <div style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "20px",
                marginTop: "20px",
                fontSize: "14px",
                color: "#0A1733"
            }}>
                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                    <div style={{
                        width: "18px",
                        height: "18px",
                        backgroundColor: "#FFA500",  // Orange
                        border: "1px solid #ccc",
                        borderRadius: "3px"
                    }} />
                    <span>Operating States</span>
                </div>

              
                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                    <div style={{
                        width: "18px",
                        height: "18px",
                        backgroundColor: "rgb(249, 179, 104)",  // Light orange/grey
                        border: "1px solid #ccc",
                        borderRadius: "3px"
                    }} />
                    <span>Non-Operating States</span>
                </div>
            </div> */}

        </div>
    );
}

